export * from './SpectrumMaterial';
export { default as LineClearEffect } from './effects/SpectrumLineClearEffect';
export { default as TetrisFinisher } from './effects/SpectrumTetrisFinisher';
export { default as HardDropTrail } from './effects/SpectrumHardDropTrail';
export { default as BlockPlaceEffect } from './effects/SpectrumBlockPlaceEffect';
export { default as BoardGrid3D } from './SpectrumBoardGrid3D';
export { default as Block3D } from './SpectrumBlock3D';
export { default as InstancedBoard } from './SpectrumInstancedBoard';

// Re-export theme config
export { THEME_CONFIG } from './SpectrumMaterial';

// Default export with all theme components
const SpectrumTheme = {
  name: 'Spectrum',
  getBlockColor: require('./SpectrumMaterial').getBlockColor,
  getEmissiveColor: require('./SpectrumMaterial').getEmissiveColor,
  COLORS: require('./SpectrumMaterial').SPECTRUM_COLORS,
  TETROMINO_COLORS: require('./SpectrumMaterial').TETROMINO_COLORS,
  config: require('./SpectrumMaterial').THEME_CONFIG,
  BoardGrid3D: require('./SpectrumBoardGrid3D').default,
  Block3D: require('./SpectrumBlock3D').default,
  InstancedBoard: require('./SpectrumInstancedBoard').default,
  effects: {
    LineClearEffect: require('./effects/SpectrumLineClearEffect').default,
    TetrisFinisher: require('./effects/SpectrumTetrisFinisher').default,
    HardDropTrail: require('./effects/SpectrumHardDropTrail').default,
    BlockPlaceEffect: require('./effects/SpectrumBlockPlaceEffect').default,
  },
};

export default SpectrumTheme;
